import { render, staticRenderFns } from "./AgendaPinned.vue?vue&type=template&id=6bb1c42a"
import script from "./AgendaPinned.vue?vue&type=script&lang=js"
export * from "./AgendaPinned.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports